import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Typing } from "../../../../Constant";
import ChatMenuIcons from "./ChatMenuIcons";

const ChatHeader = () => {
  const { selectedUser } = useAppSelector((state) => state.chatData);
  const location = useLocation();

  return (
    <div className="chat-header clearfix">
      <Image className="rounded-circle" src={dynamicImage(selectedUser?.thumb ? selectedUser?.thumb : "user/8.jpg")} alt=""/>
      <div className="about">
        <div className="name">
          {selectedUser ? selectedUser.name : "Kori Thomas"}
          {location.state ? (<span className="font-primary f-12"> {Typing}</span>) : ""}
        </div>
        <div className="status digits">
          {selectedUser ? selectedUser.lastSeenDate : "5 May, 5:30 PM"}
        </div>
      </div>
      <ChatMenuIcons />
    </div>
  );
};

export default ChatHeader;
